<template>
  <div class="content-box">
    <div class="operator">
      <div class="operator-col">
        <warehouse-input v-model="filterWarehouse"></warehouse-input>
      </div>
      <div class="operator-col">
        <hispickup v-model="filterHisDate"></hispickup>
      </div>
      <div class="operator-col">
        <enum-filter
            size="mini"
            v-model="filterExpressType.index"
            placeholder="发货类型"
            suffix-icon="el-icon-caret-bottom"
            clearable
            data-model-name="Transaction"
            field="express_type"
        ></enum-filter>
      </div>
      <div class="operator-col">
        <el-input
            size="mini"
            v-model="filterTableSearch"
            placeholder="商品名"
            suffix-icon="el-icon-search"
            clearable
        ></el-input>
      </div>
    </div>
    <curd-table
        ref="listTable"
        :data-model="editorDataModel"
        :list-ops="listOps"
        :has-op-slot="true"
        :fields="tableFields"
        :has-delete="false"
        list-url="inventory/list_tx/send"
        :search-filter="filterTableSearch"
        :warehouse-filter="filterWarehouse"
        :kv-filter="kvFilter"
        :has-expand-show="true"
        :is-selectable="true"
        :batch-ops="[{key:'doHasSendTx',name:'发货'}]"
        @click-batch-op="handleClickList"
    >
      <template slot="expandShow" slot-scope="scope">
        <div>
          <h5>备注</h5>
          <p>{{scope.row.desc}}</p>
        </div>
        <table class="table table-bordered">
          <tr v-for="tx_item in scope.row.tx_items" :key="tx_item._id">
            <td v-for="(key,index) in itemTableFields" :key="index">
              <field-show
                  :field-info="dataModels.Tx_item[key.name]"
                  :value="tx_item[key.name]"
                  :field-key="key"
              ></field-show>
            </td>
          </tr>
        </table>
      </template>
      <template slot="listOp" slot-scope="scope">
        <el-button size="mini" type="text" @click="goTxInfo(scope.row._id)">详情</el-button>
        <el-button
            size="mini"
            type="text"
            @click="goSendTx(scope.row._id)"
            v-if="scope.row.status.index==10 "
        >发货</el-button>
        <!-- <el-button
          size="mini"
          type="text"
          @click="goRejectTx(scope.row._id)"
          v-if="scope.row.status.index==10 "
        >打回</el-button>-->
      </template>
    </curd-table>
    <editor
        :show.sync="editorVisible"
        :data-model-name="editorDataModel"
        :record-id="editorId"
        :fields="sendFields"
        handler-url="inventory/do_tx_op/send"
        @change="refreshTable('listTable')"
    ></editor>
	<!-- 新加的 -->
	<editorList
        :show.sync="editorVisibles"
        :data-model-name="editorDataModel"
        :record-ids="editorIds"
		:record-id="editorIds[0]"
        :fields="getFields"
        handler-url="inventory/do_tx_op/send"
        @change="refreshTable('listTable')"
    ></editorList>
  </div>
</template>

<script>
import CurdPage from "@/mixins/CurdPage.js";
import Filters from "@/mixins/Filters.js";
import FilterWarehouse from "@/mixins/Filter/FilterWarehouse.js";
import FilterExpressType from "@/mixins/Filter/FilterExpressType";

import LoadDM from "@/mixins/LoadDM.js";
import TxOp from "@/mixinsApp/TxOp.js";
import axios from "axios";
import qs from "qs";

export default {
  mixins: [CurdPage, Filters, FilterWarehouse, FilterExpressType, TxOp, LoadDM],

  data() {
    return {
      loadings: {
        main: false,
      },
      editorDataModel: "Transaction",
      dataModelNames: ["Transaction", "Tx_item"],
      listOps: [
        {
          name: "info",
          show_name: "详情",
          handler: "goinfo",
        },
      ],
      tableFields: [
        {
          name: "show_id",
        },
        {
          name: "warehouse",
          sortable: "custom",
        },
        {
          name: "customer",
          sortable: "custom",
          width: "90px",
        },
        {
          name: "express_type",
          render: info => {
            return "[" + info.express_type.name + "] " + info.address.name;
          },
        },
        {
          name: "order",
          params: {
            link: "Order-Info",
          },
        },
        {
          name: "order_show_id",
        },
        {
          name: "name",
          sortable: "custom",
        },

        {
          name: "total_price",
          sortable: "custom",
        },
        {
          name: "tx_at",
          sortable: "custom",
        },
      ],
    };
  },

  methods: {
    doHasSendTx(id){
      this.payIsIncome = true;
      this.payEditorId = id;
      this.payEditorVisible = true;
      console.log(id)
    },
	//新加的方法
	handleList(checks){
	this.batchConfirmList = {
        count: 0,
        recordIds: [],
		showIds:[],
		showNames:[],
      };
	  const datas = this.$refs["listTable"].tableData.filter((v, k) => {
        return checks[k];
      });


	  datas.forEach(v => {
        this.batchConfirmList.count++;
        this.batchConfirmList.recordIds.push(v._id);
		this.batchConfirmList.showIds.push(v.show_id);
		this.batchConfirmList.showNames.push(v.name);
      });
	  this.$store.commit('showIdList',this.batchConfirmList.showIds)
	  this.$store.commit('showNameList',this.batchConfirmList.showNames)
	  this.goSendTxy(this.batchConfirmList.recordIds)

	},




    handleBatch_doHasSendTx(checks)
    {
      this.batchConfirmInfo = {
        count: 0,
        recordIds: [],
      };
	  console.log('5656',this.$refs["listTable"].tableData)
      const data = this.$refs["listTable"].tableData.filter((v, k) => {
        return checks[k];
      });
      data.forEach(v => {
        this.batchConfirmInfo.count++;
        this.batchConfirmInfo.recordIds.push(v._id);
      });

      console.log(this.batchConfirmInfo.recordIds)
      this.goSendTx(this.batchConfirmInfo.recordIds)
    },
  },
  watch: {
    $route() {
      this.refreshTable("listTable");
    },
    "filterExpressType.value": {
      handler(newVal) {
        let val = this.filterExpressType;
        if (val.value != null && val.value !== "") {
          this.$set(this.kvFilter, val.field, { k: val.field, t: "int", v: val.value });
        } else {
          this.$delete(this.kvFilter, val.field);
        }
      },
      immediate: true,
    },
  },
};
</script>
<style lang="scss" scoped>
</style>